// Hide header with extra buttons/actions for checkboxes
export default function(tableId) {

  // Re-set the "preselect-all" checkboxes option for the table
  $('#' + tableId).attr('data-preselect-all', 'false');

  // Uncheck the "select all" checkbox option in the header
  $('.select-displayed-cells').prop('checked', false);

  // Remove the option to unselect all
  $('.checkbox-minus').remove();

  // Un-check all checked cells in the table
  $('#' + tableId + ' tr .checkbox').prop('checked', false);

  // Remove associated SVGs that indicate a checkbox is checked
  $('#' + tableId + ' tr .checkbox-svg').remove();

  // Update the header row
  let tr = $('.dataTables_scrollHeadInner').find('thead tr');
  tr.removeClass('bg-gray100');
  tr.find('th').removeClass('bg-gray100');
  tr.find('th:not(:first-child)').css('opacity', 1);
  $('.hidden-header-buttons').removeClass('d-flex').addClass('d-none');
  
  // Reset record ids on table
  $('#' + tableId).data('record-ids', []);

}